import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '../../../images/icons/chevronLeft.svg';
import mobileLogoHorz from '../../../images/mobile/mobile_logo_horz2.svg';
import { Button } from '@material-ui/core';

// const drawerWidth = 240;
const styles = () => {
	return {
		appBar: {
			width: '100%',
			position: 'fixed',
			backgroundColor: '#0D5D90',
			height: '12vw',
		},
		logo: {
			//width: '3.08vw',
			height: '5vw',
			padding: '3.0vw',
			//height: 44,
		},
		title: {
			textAlign: 'center',
			fontSize: '225%',
			fontWeight: 800,
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},

		backButton: {
			borderRadius: 6,
			width: '12vw',
			position: 'absolute',
			left: 0,
			top: 0,
			bottom: 0,
		},
		backButtonIcon: {
			display: 'inline-block',
			width: '2.2vw',
			height: '5vw',
			backgroundImage: `url('${ChevronLeftIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
		},
	};
};

class MobileHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		//const { authUser } = this.props;
		const { classes, label, children, showLogo, showBack } = this.props;
		return (
			<AppBar className={classes.appBar}>
				{showBack && (
					<Button
						className={classes.backButton}
						aria-label="Back"
						onClick={() => {
							console.log(this.props.history);
							this.props.history.goBack();
						}}
					>
						<span className={classes.backButtonIcon} />
					</Button>
				)}

				{showLogo && <img alt="Logo" src={mobileLogoHorz} className={classes.logo} />}
				{!!label && (
					<div className={classes.title} style={{ fontSize: label.length > 18 ? '150%' : '200%' }}>
						{label}
					</div>
				)}
				{children}
			</AppBar>
		);
	}
}

MobileHeader.propTypes = {
	classes: PropTypes.object.isRequired,
	showLogo: PropTypes.bool,
	label: PropTypes.string,
	children: PropTypes.node,
	history: PropTypes.object,
	showBack: PropTypes.bool,
};

export default _.flow([withStyles(styles)])(MobileHeader);
